import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/core/interfaces/store';

const analysesSelector = (state: RootState) => state.analyses;

export const getAnalysesSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.analyses
);

export const getGeolocatedAnalysesSelector = createSelector([getAnalysesSelector], analyses =>
  analyses.filter(analysis => {
    const location = analysis.meta?.locations?.[0];

    return typeof location?.latitude === 'number' && typeof location?.longitude === 'number';
  })
);

export const isEditAnalysisModalOpenSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.isEditAnalysisModalOpen
);

export const selectedAnalysisSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.selectedAnalysis
);

export const isAnalysisViewModalOpenSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.isAnalysisViewModalOpen
);

export const isChatBotModalOpenSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.isChatBotModalOpen
);

export const chatBotFocusIdSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.chatBotFocusId
);

export const isAnalysisLoadingForIdSelector = (state: RootState, id: number | null): boolean =>
  id != null && state.analyses.getAnalysisLoading && state.analyses.getAnalysisRequestId === id;

export const isAnalysisErrorForIdSelector = (state: RootState, id: number | null): boolean =>
  id != null && state.analyses.getAnalysisError && state.analyses.getAnalysisRequestId === id;

export const tokenUsageSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.tokenUsage
);

export const tokenUsageLoadingSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.tokenUsageLoading
);

export const tokenUsageErrorSelector = createSelector(
  [analysesSelector],
  analysesState => analysesState.tokenUsageError
);

export const tokenUsagePercentageSelector = createSelector([analysesSelector], analysesState => {
  const { tokenUsage } = analysesState;

  if (!tokenUsage) return 0;

  const total = tokenUsage.usedTokens + tokenUsage.remainingTokens;

  if (total === 0) return 0;

  return Math.min(100, Math.round((tokenUsage.usedTokens / total) * 100));
});
